import Typography from "@mui/joy/Typography";
import GetAppIcon from "@mui/icons-material/GetApp";
import Stack from "@mui/joy/Stack";

interface Props {
  exportToCSV: Function;
  disabled?: boolean;
}

const ExportToCSV = ({ exportToCSV, disabled }: Props) => {
  return (
    <Stack
      component={"button"}
      type="button"
      disabled={disabled}
      alignItems={"center"}
      justifyContent={"center"}
      className="noselect"
      sx={{
        bgcolor: "#F0F4F8",
        width: "28px",
        py: 4,
        height: "120px",
        border: "1px solid",
        borderColor: "neutral.300",
        borderRadius: "sm",
        cursor: "pointer",
        "&:disabled": {
          opacity: "50%",
          cursor: "not-allowed",
        },
      }}
      onClick={() => {
        exportToCSV();
      }}
    >
      <Typography
        noWrap
        sx={{
          transform: "rotate(90deg)",
        }}
        fontSize={"sm"}
        startDecorator={<GetAppIcon />}
      >
        Export CSV
      </Typography>
    </Stack>
  );
};
export default ExportToCSV;
